import React from "react";
import PropTypes from "prop-types";

import "./ResourceTitle.scss";

const ResourceTitle = (props) => {
  const { titlePrefix = "IP Address", titleStr } = props;

  if (!titleStr) {
    return null;
  }

  return (
    <div className="resources-view-title">
      {titlePrefix && <span>{`${titlePrefix}: `}</span>}

      <span className="resources-view-title-main">{titleStr}</span>
    </div>
  );
};

ResourceTitle.propTypes = {
  titlePrefix: PropTypes.string,
  titleStr: PropTypes.string,
};

ResourceTitle.defaultProps = {
  titlePrefix: "",
  titleStr: "",
};

export default ResourceTitle;
